/* theme.js — shared init. Vanilla, progressive enhancement. */
(function () {
  "use strict";

  // Shared focus-trap helper (used by mega-menu.js)
  window.Theme = window.Theme || {};
  window.Theme.trapFocus = function (container) {
    const focusables = container.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])',
    );
    if (!focusables.length) return function () {};
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    function onKey(e) {
      if (e.key !== "Tab") return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    container.addEventListener("keydown", onKey);
    first.focus();
    return function () {
      container.removeEventListener("keydown", onKey);
    };
  };

  // Quantity steppers
  document.addEventListener("click", function (e) {
    const minus = e.target.closest("[data-qty-minus]");
    const plus = e.target.closest("[data-qty-plus]");
    if (!minus && !plus) return;
    const wrap = e.target.closest("[data-qty]");
    const input = wrap && wrap.querySelector("[data-qty-input]");
    if (!input) return;
    let v = parseInt(input.value, 10) || 1;
    v = plus ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  // Cart page: submit the native cart form when a line quantity changes so the
  // update applies (drawer AJAX was removed in favour of a dedicated /cart page).
  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-cart-form] input[name^='updates']");
    if (!input) return;
    var form = input.closest("[data-cart-form]");
    if (form) form.submit();
  });

  // (Collection sort is handled by collection-filters.js so it preserves active filters.)

  // PDP gallery thumbnails
  document.addEventListener("click", function (e) {
    const thumb = e.target.closest("[data-thumb]");
    if (!thumb) return;
    const main = document.querySelector("[data-main-image]");
    if (main) main.src = thumb.getAttribute("data-thumb");
  });

  // Back-to-top button
  var toTop = document.querySelector("[data-back-to-top]");
  if (toTop) {
    var onScroll = function () {
      toTop.classList.toggle("is-visible", window.scrollY > 600);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    toTop.addEventListener("click", function () {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  // Cart urgency timer (MM:SS countdown)
  var timerEl = document.querySelector("[data-cart-timer]");
  if (timerEl) {
    var mins = parseInt(timerEl.getAttribute("data-minutes"), 10) || 8;
    var remaining = mins * 60;
    var tick = function () {
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      timerEl.textContent = (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
      if (remaining > 0) remaining -= 1;
    };
    tick();
    var iv = setInterval(function () {
      if (remaining <= 0) { clearInterval(iv); return; }
      tick();
    }, 1000);
  }
})();
